import firebase from 'firebase';
import '@firebase/firestore';

const config = {
	apiKey: 'AIzaSyB5IWmuh7Pa91qaS_GT16PbrZJF8O5-23Y',
	authDomain: 'arseblogratings.firebaseapp.com',
	databaseURL: 'https://arseblogratings.firebaseio.com',
	projectId: 'arseblogratings',
	storageBucket: 'arseblogratings.appspot.com',
	messagingSenderId: '660412271106',
};
const Fire = firebase.initializeApp(config);
const firestore = firebase.firestore();
const settings = { timestampsInSnapshots: true };
firestore.settings(settings);
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const firebaseAuth = firebase.auth;
export const firebaseStorage = firebase.storage();
export default Fire;



// WEBPACK FOOTER //
// ./src/config/Fire.js